import React from 'react';
import { Filter as FilterAdmin, TextInput, BooleanInput } from 'react-admin';

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="nome" />
    <BooleanInput label="Em uso" source="usado" />
  </FilterAdmin>
);

export default Filter;
